exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".debug-selection[data-v-2694d64b]{border:2px solid #ff4500;padding:5px;margin-bottom:10px}.debug-item[data-v-2694d64b]{padding:5px}.width-adapted[data-v-2694d64b]{max-width:220px;margin:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2694d64b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/DebugHeaderWithSelection.vue
// module id = 470
// module chunks = 0